/**
 * Преобразует Base64-строку в объект File.
 * Автоматически определяет тип контента из Base64-строки.
 *
 * @param base64Data Строка в формате Base64 (например, "data:image/png;base64,...").
 * @param fileName Имя файла (по умолчанию "file").
 * @returns File
 *
 * @example
 * ```typescript
 * // Для изображения
 * const imageFile = base64ToFile('data:image/png;base64,...', 'image');
 * // Результат: File {name: "image.png", type: "image/png"}
 *
 * // Для видео
 * const videoFile = base64ToFile('data:video/mp4;base64,...', 'video');
 * // Результат: File {name: "video.mp4", type: "video/mp4"}
 * ```
 */
export function base64ToFile(base64Data: string, fileName = "file"): File {
  // Получаем MIME-тип и данные из base64
  const matches = base64Data.match(/^data:(.+);base64,(.+)$/);

  // Если нет соответствия формату data URL, считаем что переданы чистые base64 данные
  const mimeType = matches ? matches[1] : "image/png";
  const base64String = matches ? matches[2] : base64Data;

  // Определяем расширение файла из MIME-типа
  const extension = mimeType.split("/")[1] || "png";

  // Формируем полное имя файла
  const fullFileName = fileName.endsWith(`.${extension}`)
    ? fileName
    : `${fileName}.${extension}`;

  // Декодируем Base64
  const binaryString = atob(base64String);
  const byteArray = new Uint8Array(binaryString.length);

  for (let i = 0; i < binaryString.length; i++) {
    byteArray[i] = binaryString.charCodeAt(i);
  }

  return new File([byteArray], fullFileName, { type: mimeType });
}
